import { ClosedCaptionIcon } from './ClosedCaptionIcon';

/**
 * author: Google
 * id 5367B460-F7E5-46C5-A4F5-40B339BF9DAD
 * name closed-caption
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/closed-caption.svg
 * tags
 */
export const CcIcon = ClosedCaptionIcon;
export default CcIcon